export const FINAL_SALE_COPY = '- Not Eligible for Return';
export const FINAL_SALE_SHORT_COPY = '- Item is not returnable.';
export const FINAL_SALE_TEXT = 'Final Sale ';
